export const Action = (action) => {
  return {
    type: action.type,
    payload: action.payload,
  };
};
